import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { PostState } from '@/store/types/post.state';

export const getters: GetterTree<PostState, RootState> = {
    
};